import { Button, Table } from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { FiDownload } from "react-icons/fi";
import { useNavigate } from "react-router";
import Moment from "moment";
// Components
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import CommonFilterModal from "../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import Pagination from "../../components/Common/CommonPagination";
// import Pagination from "../../components/Common/CommonPagination";

import NavBarTitles from "../../components/Common/TabBar";
import ExcelDownload from "../../components/Utils/excelDownload";
import ExcelDownloadModal from "../../Pages/Masters/Common/excelDownloadAccess";
import MainconternLayout from "../../components/Layout/MainconternLayout";

// Hooks
import useSortHandler from "../../components/Utils/hooks/useSortHandler";

// Constants
import { careernavBarData, careersrBreadcrumbs, Gender } from "./const";

// Styles
import "./careers.scss";
import SelectComponent from "../../components/Common/Select";
import scroll from "../../assets/webp/scroll.webp";
// import CommonFIlterModal from "../../components/Common/CommonFilterModal";

const fileDotExts = {
  "application/msword": ".doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    ".docx",
  "application/pdf": ".pdf",
  unknown: ".pdf",
};

const Careers = () => {
  const navigate = useNavigate();

  const [pages, setPages] = useState(0);
  const [pagination, setPagination] = useState({});
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");
  const [records, setRecords] = useState([]);

  //filter portion
  const [filtershow, setFilterShow] = useState(false);
  const [sortshow, setSortShow] = useState(false);
  const [textcolor, setTextColor] = useState(0);
  const [pageOffset, setPageOffset] = useState(0);

  const [designationdata, setDesignationData] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [acrossHealthsyData, setAcrossHealthsyData] = useState([]);
  const [genderdata, setGenderdata] = useState([]);
  const [location, setLocation] = useState("");
  const [search, setSearch] = useState(0);
  const [filter] = useState({ name: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const handleSortClick = useSortHandler(setSort, setSortName);
  const [loader, setLoader] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("Gender");
  const [selectedValues, setSelectedValues] = useState({
    Gender: [],
    "City / Town": [],
    Designation: [],
    "Across Healthsy": [],
  });

  const Filters = {
    Gender: genderdata,
    "City / Town": [],
    Designation: designationdata,
    "Across Healthsy": acrossHealthsyData,
  };

  useEffect(() => {
    if (
      selectedValues["Gender"].length > 0 ||
      selectedValues["City / Town"].length > 0 ||
      selectedValues["Designation"].length > 0 ||
      selectedValues["Across Healthsy"].length > 0
    ) {
      // filterRecordsFromSelected();
    }
  }, [records]);

  useEffect(() => {
    (async () => {
      setLoader(true);
      const genderResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}gender/getarray`
      );
      if (genderResponse.data) {
        setGenderdata(genderResponse.data);
      }
    })();
  }, []);

  // const base64ToBlob = async ({
  //   uploadResume: base64String,
  //   name,
  //   location,
  // }) => {
  //   if (base64String.includes("data:application/")) {
  //     const link = document.createElement("a");
  //     const ext =
  //       fileDotExts[
  //         base64String.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)[1] ??
  //           "unknown"
  //       ];
  //     link.href = base64String;
  //     link.download = name + " " + location + ext;
  //     link.click();
  //   } else {
  //     axios({
  //       url: `${process.env.REACT_APP_API_URL}career/download/${base64String}`,
  //       method: "GET",
  //       responseType: "blob",
  //     }).then((response) => {
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute(
  //         "download",
  //         response?.config?.url?.split("-")?.slice(1).join("_")
  //       );
  //       document.body.appendChild(link);
  //       link.click();
  //     });
  //   }
  // };


const base64ToBlob = async ({ uploadResume: base64String, name, location }) => {
  // Case 1: Resume is stored as base64
  if (base64String.includes("data:application/")) {
    const link = document.createElement("a");
    const ext =
      fileDotExts[
        base64String.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)[1] ??
          "unknown"
      ];
    link.href = base64String;
    link.download = `${name} ${location}${ext}`;
    link.click();
    return;
  }

  // Case 2: Resume is a URL (DigitalOcean Spaces or similar)
  try {
    // Try direct download using <a> (avoids CORS issues)
    const link = document.createElement("a");
    link.href = base64String;
    link.setAttribute("download", base64String.split("/").pop()); // filename from URL
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.warn("Direct download failed, trying backend proxy…", err);

    // Fallback → download via backend proxy
    const fileName = base64String.split("/").pop(); // extract filename
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}career/download/${fileName}`,
        method: "GET",
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (proxyError) {
      console.error("Resume download failed via backend:", proxyError);
    }
  }
};


  const handleJobPost = () => {
    navigate("/careerjobpost");
  };

  const handleDepartment = () => {
    navigate("/careerdepartment");
  };

  const handlePosition = () => {
    navigate("/careerposition");
  };

  useEffect(() => {
    setLoader(true);
    list_api_call();
  }, [search, limit, filter, sort, skip]);

  const handlePageChange = (event) => {
    setSkip(event.selected * limit);
    setPageOffset(event.selected);
  };

  useEffect(() => {
    handlePageChange({ selected: 0 });
  }, [search, limit]);

  const list_api_call = async (clearFilter = false) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}career/list`,
        {
          key: "job_post",
          filterValues: clearFilter
            ? {}
            : {
                gender: genderdata,
                location: location,
                desgination: designationList,
                acrossHealthsy: acrossHealthsyData,
              },
          sort,
          skip,
          limit,
          searchData: search,
        }
      );
      setRecords(response.data.careers);
      setPagination(response.data.pagination);
      setPages(response.data.pagination.totalPages);
    } catch (err) {
      console.error(err);
    }
  };

  const filter_call = () => {
    setLoader(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}career/list`, {
        filterValues: {
          gender: selectedValues["Gender"],
          location: selectedValues["City / Town"],
          desgination: selectedValues["Designation"],
          acrossHealthsy: selectedValues["Across Healthsy"],
        },
        sort,
        skip,
        limit,
        searchData: search,
      })
      .then((res) => {
        setRecords(res.data.careers);
        setPages(res.data.pagination.totalPages);
      });
  };

  useEffect(() => {
    getDesgination();
  }, []);

  const getDesgination = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}career-add-job-post/list`)
      .then((res) => {
        setDesignationData(res.data.rows.map((data) => data?.designation));
      });
  };

  useEffect(() => {
    if (location) {
      filter_Location_Search_call();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const filter_Location_Search_call = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}filters/location`, {
        key: "careers",
        values: {
          location: location,
        },
      })
      .then((res) => {
        setRecords(res.data);
      });
  };

  const handleContact = (id) => {
    setLoader(true);
    axios
      .patch(`${process.env.REACT_APP_API_URL}career/update/${id}`, {
        contact: true,
        reject: false,
        select: false,
        interview: false,
        notContact: false,
      })
      .then((result) => {
        list_api_call();
      });
  };

  //Not Contact Functionality
  const handleNotContact = (id) => {
    setLoader(true);
    axios
      .patch(`${process.env.REACT_APP_API_URL}career/update/${id}`, {
        contact: false,
        reject: false,
        select: false,
        interview: false,
        notContact: true,
      })
      .then((result) => {
        list_api_call();
      });
  };

  //Reject Functionality
  const handleReject = (id) => {
    setLoader(true);
    axios
      .patch(`${process.env.REACT_APP_API_URL}career/update/${id}`, {
        contact: false,
        reject: true,
        select: false,
        interview: false,
        notContact: false,
      })
      .then((result) => {
        list_api_call();
      });
  };

  //Select Functionality
  const handleSelect = (id) => {
    setLoader(true);
    axios
      .patch(`${process.env.REACT_APP_API_URL}career/update/${id}`, {
        contact: false,
        reject: false,
        select: true,
        interview: false,
        notContact: false,
      })
      .then((result) => {
        list_api_call();
      });
  };

  //Interview Functionality
  const handleInterview = (id) => {
    setLoader(true);
    axios
      .patch(`${process.env.REACT_APP_API_URL}career/update/${id}`, {
        contact: false,
        reject: false,
        select: false,
        interview: true,
        notContact: false,
      })
      .then((result) => {
        list_api_call();
      });
  };

  const debouncedSearch = debounce((value) => {
    handlePageChange({ selected: 0 });
    setSearch(value); // Update the state after debounce
  }, 500);

  const onChangeSearch = (value) => {
    debouncedSearch(value);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const actionOptions = [
    { label: "Option", value: "Option" },
    { label: "Contact", value: "Contact" },
    { label: "Reject", value: "Reject" },
    { label: "Select", value: "Select" },
    { label: "Interview", value: "Interview" },
    { label: "Not Contacted", value: "NotContacted" },
  ];

  const getCurrentAction = (record) => {
    if (record.contact) return "Contact";
    if (record.reject) return "Reject";
    if (record.select) return "Select";
    if (record.interview) return "Interview";
    if (record.notContact) return "NotContacted";
    return "option";
  };

  const columns = [
    { title: "S.No", dataIndex: "sno", key: "sno", fixed: "left", width: 80 },
    {
      title: "Name of the Candidate",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 240,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD-MM-YYYY LT"),
      width: 220,
    },

    // {
    //   title: "Date of Registration",
    //   dataIndex: "createdAt",
    //   render: (text) => Moment(text).format("DD-MM-YYYY"),
    //   width: 220,
    // },
    {
      title: "Last updated on",
      dataIndex: "updatedAt",
      render: (text) => Moment(text).format("DD-MM-YYYY"),
      width: 220,
    },
    { title: "Mobile Number", dataIndex: "mobile", key: "mobile", width: 180 },
    { title: "Email ID", dataIndex: "email", key: "email", width: 350 },
    { title: "Age", dataIndex: "age", key: "age", width: 80 },
    { title: "Gender", dataIndex: "gender", key: "gender", width: 120 },
    {
      title: "Job Position",
      dataIndex: "jobPosition",
      width: 600,
      key: "jobPosition",
      width: 350,
    },
    {
      title: "Educational Qualification",
      dataIndex: "educationQualification",
      key: "educationQualification",
      width: 250,
    },
    {
      title: "City / Town",
      dataIndex: "location",
      key: "location",
      width: 130,
    },
    {
      title: "Hyperlinks",
      dataIndex: "hyperLink",
      key: "hyperLink",
      width: 350,
      render: (links) => (
        <>
          {links?.map((link, i) => (
            <div key={i}>
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-blue fs13"
              >
                {link}
              </a>
            </div>
          ))}
        </>
      ),
    },
    {
      title: "Resume CV",
      dataIndex: "cv",
      key: "cv",
      width: 150,
      render: (_, record) => (
        <Button className="downloadBtn" onClick={() => base64ToBlob(record)}>
          <div className="d-flex align-items-center">
            Download
            <FiDownload className="ml-2" />
          </div>
        </Button>
      ),
    },
    {
      title: "Across Healthsy",
      dataIndex: "acrossHealthsy",
      width: 200,
      key: "acrossHealthsy",
      render: (val) => val || "-",
    },
    // {
    //   title: "Actions",
    //   key: "actions",
    //   width: 400,
    //   render: (_, record) => (
    //     <div className="d-flex flex-wrap gap-2">
    //       <span
    //         className={`career-contact ${record.contact ? "career-contact-bold" : ""}`}
    //         onClick={() => handleContact(record._id)}
    //       >
    //         Contact
    //       </span>
    //       <span className="career-contact-icon">
    //         <img src={contact} alt="" />
    //       </span>

    //       <span
    //         className={`career-reject ${record.reject ? "career-reject-bold" : ""}`}
    //         onClick={() => handleReject(record._id)}
    //       >
    //         Reject
    //       </span>
    //       <span className="career-reject-icon">
    //         <img src="" alt="" />
    //       </span>

    //       <span
    //         className={`career-select ${record.select ? "career-select-bold" : ""}`}
    //         onClick={() => handleSelect(record._id)}
    //       >
    //         Select
    //       </span>
    //       <span className="career-selct-icon">
    //         <img src="" alt="" />
    //       </span>

    //       <span
    //         className={`career-interview ${record.interview ? "career-interview-bold" : ""}`}
    //         onClick={() => handleInterview(record._id)}
    //       >
    //         Interview
    //       </span>
    //       <span className="career-interview-icon">
    //         <img src="" alt="" />
    //       </span>

    //       <span
    //         className={`career-not-contact ${record.notContact ? "career-not-contact-bold" : ""}`}
    //         onClick={() => handleNotContact(record._id)}
    //       >
    //         Not Contacted
    //       </span>
    //       <span className="career-not-contact-icon">
    //         <img src={notcontact} alt="" />
    //       </span>
    //     </div>
    //   ),
    // },
    {
      title: "Actions",
      key: "actions",
      width: 200,
      render: (_, record) => (
        // <select
        //   className="bg-white"
        //   style={{ color: "#CB1B5B", minWidth: "140px", borderRadius: "5px", border: "1px solid" }}
        //   value={getCurrentAction(record)}
        //   onChange={(e) => {
        //     const value = e.target.value;
        //     if (value === "Contact") handleContact(record._id);
        //     else if (value === "Reject") handleReject(record._id);
        //     else if (value === "Select") handleSelect(record._id);
        //     else if (value === "Interview") handleInterview(record._id);
        //     else if (value === "NotContacted") handleNotContact(record._id);
        //   }}
        // >
        //   {actionOptions.map((opt) => (
        //     <option key={opt.value} value={opt.value}>
        //       {opt.label}
        //     </option>
        //   ))}
        // </select>
        <SelectComponent
          props={{
            Array: actionOptions,
            value: getCurrentAction(record),
            style: { color: "#CB1B5B", width: "200px" },
            onChange: (e) => {
              const value = e;
              if (value === "Contact") handleContact(record._id);
              else if (value === "Reject") handleReject(record._id);
              else if (value === "Select") handleSelect(record._id);
              else if (value === "Interview") handleInterview(record._id);
              else if (value === "NotContacted") handleNotContact(record._id);
            },
          }}
        />
      ),
    },
  ];

  const formattedData = records
    ?.filter((el) => el.show === undefined || el.show === true)
    ?.map((el, index) => {
      let res = [];

      // Hyperlink parsing
      if (
        !el?.hyperLink?.length ||
        (el?.hyperLink?.length && el?.hyperLink[0]?.id)
      ) {
        res = Object.values(el.hyperLink).map((obj) => Object.values(obj)[0]);
      } else {
        const hype = Object.values(el.hyperLink).map((i) => Object.values(i));
        const hyperlink = Object.values(hype)[0] || [];
        res = Object.values(hyperlink).map((i) => Object.values(i)[0]);
      }

      return {
        ...el,
        key: el._id,
        sno: skip + (index + 1),
        hyperLink: res,
      };
    });

  const onClickDownload = async () => {
    try {
      const formattedRecords = records.map((record, index) => {
        let hyperlinks = "";
        if (record.hyperLink) {
          if (
            !record.hyperLink?.length ||
            (record.hyperLink?.length && record.hyperLink[0]?.id)
          ) {
            hyperlinks = Object.values(record.hyperLink)
              .map((obj) => Object.values(obj)[0])
              .join(", ");
          } else {
            const hype = Object.values(record.hyperLink)
              .map((i) => Object.values(i))
              .flat();
            let hyperlink;
            Object.keys(hype).forEach((x) => {
              hyperlink = hype[x];
            });
            hyperlinks = Object.values(hyperlink)
              .map((i) => Object.values(i)[0])
              .join(", ");
          }
        }

        return {
          "S.No": index + 1,
          "Time of Registration": record.createdAt
            ? new Date(record.createdAt).toLocaleTimeString()
            : "",
          "Date of Registration": record.createdAt
            ? new Date(record.createdAt).toLocaleDateString()
            : "",
          "Name of the Candidate": record.name || "",
          "Mobile Number": record.mobile || "",
          "Email ID": record.email || "",
          Age: record.age || "",
          Gender: record.gender || "",
          "Job Position": record.jobPosition || "",
          "Educational Qualification": record.educationQualification || "",
          "City / Town": record.location || "",
          Hyperlinks: hyperlinks,
          "Across Healthsy": record.acrossHealthsy || "",
        };
      });
      ExcelDownload(formattedRecords, "", "career.xlsx");
    } catch (err) {
      console.error(
        "Error downloading the file while getting all Doctor registration records",
        err,
        "err.message",
        err?.message
      );
      alert(err?.message || "An error occurred while downloading the file.");
    }
  };

  const breadcrumbsList = useMemo(() => [{ text: "Careers", link: "" }], []);

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);
  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={careersrBreadcrumbs}
            />
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              Total careers: {pages * limit}
            </div>
            {pagination.totalItems > limit && (
              <Pagination
                skip={skip}
                limit={limit}
                total={pages * limit}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={careernavBarData} />
          <DoctorsFilterOptions
            limit={limit}
            sortName={sortName}
            search={search}
            setFilterShow={() => setIsFilterModalVisible(true)}
            setSortShow={setSortShow}
            onChange={onChangeSearch}
            setLimit={setLimit}
            downloadExcel={true}
            onClickDownload={showModal}
            handleSortClick={handleSortClick}
          />

          {/* <DoctorsFilterOptions
            limit={limit}
            sortshow={sortshow}
            sortName={sortName}
            search={search}
            setFilterShow={setFilterShow}
            setSortShow={setSortShow}
            onChange={onChangeSearch}
            setLimit={setLimit}
            downloadExcel={true}
            onClickDownload={showModal}
          /> */}
          {!loader ? (
            <Table
              bordered
              columns={columns}
              dataSource={formattedData}
              pagination={false}
              rowKey="_id"
              className="mx-3 pt-2 table-scrollable masterList_table"
              scroll={{ x: "max-content" }}
            />
          ) : (
            <div className="d-flex justify-content-center">
              <img src={scroll} width={150} alt="loader" />
            </div>
          )}
        </div>
        <CommonFilterModal
          visible={isFilterModalVisible}
          onClose={() => {
            setIsFilterModalVisible(false);
            setSelectedCategory(Object.keys(Filters)[0]); // Reset to first category
          }}
          onApply={() => {
            setIsFilterModalVisible(false);
            setSelectedCategory(Object.keys(Filters)[0]); // Reset to first category
            // filterRecordsFromSelected();
            filter_call();
          }}
          onReset={() => {
            setSelectedValues({
              Gender: [],
              "City / Town": [],
              Designation: [],
              "Across Healthsy": [],
            });
            // setFilteredRecords([]);
            setSelectedCategory(Object.keys(Filters)[0]); // Reset on reset too (optional)
          }}
          filters={Filters}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedValues={selectedValues}
          setSelectedValues={setSelectedValues}
          searchOnlyCategories={["City / Town"]}
        />
      </MainconternLayout>

      {/* </Home> */}
      {/* 
        {filtershow ? (
      //   <FiltersRootModal
      //     filterOptions={careersFilterOptions}
      //     onClickClear={() => {
      //       list_api_call(true);
      //       setFilterShow(false);
      //       setGenderdata([]);
      //       setDesignationList([]);
      //       setLocation([]);
      //       setAcrossHealthsyData([]);
      //     }}
      //     onClickApply={() => {
      //       setFilterShow(false);
      //       filter_call();
      //     }}
      //     selectOption={textcolor}
      //     setSelectOption={setTextColor}
      //   />
       ) : null} */}

      {/*---------Gender---------*/}
      {/* {textcolor === 1 && filtershow === true ? (
        <FilterModal
          title={"Gender"}
          data={gender}
          className="filterModelNestedLevel filterModelOptions"
          activeFilters={genderdata}
          onChange={(e) => {
            const selectedGender = e.target.name;
            if (genderdata.includes(selectedGender)) {
              setGenderdata(
                genderdata.filter((gender) => gender !== selectedGender),
              );
            } else {
              setGenderdata((prev) => [...prev, selectedGender]);
            }
          }}
        />
      ) : null} */}

      {/*-------Location--------*/}
      {/* {textcolor === 2 && filtershow === true ? (
        <div className="filter-doctor-fee-career">
          <div className="filter-doctor-fee-header">Location</div>
          <div className="filter-doctor-fee-hr"></div>
          <div className="filter-doctor-fee-container">
            <div className="filter-doctor-search">
              <div>
                <div>
                  <img src={search} alt="" />
                </div>
                <div>
                  <input
                    type="text"
                    name=""
                    id="filter-search"
                    placeholder="Search"
                    onChange={(e) => setLocation(e.target.value)}
                  />
                  <Autocomplete
                    apiKey={"AIzaSyBJUZFe3zt4HNVzwdTlmJYMWtXhZ7mfclk"}
                    onPlaceSelected={(place) => {
                      const city = place.address_components.find((component) =>
                        component.types.includes("locality"),
                      );
                      setLocation(
                        city ? city.long_name : place.formatted_address,
                      );
                    }}
                    types={["address"]}
                    className="form-control newlocation"
                    defaultValue={location}
                    placeholder=""
                    componentRestrictions={{ country: "us" }}
                    preventDefault
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null} */}

      {/*-------Designation--------*/}
      {/* {textcolor === 3 && filtershow === true ? (
        <FilterModal
          title={"Designation"}
          data={designationdata}
          className="filterModelNestedLevel filterModelOptions"
          activeFilters={designationList}
          onChange={(e) => {
            if (designationList.includes(e.target.name)) {
              setDesignationList(
                designationList.filter((ele) => ele !== e.target.name),
              );
            } else {
              setDesignationList((pre) => [...pre, e.target.name]);
            }
          }}
        />
      ) : null} */}

      {/*-------AcrossHealthsy--------*/}
      {/* {textcolor === 4 && filtershow === true ? (
        <FilterModal
          title={"AcrossHealthsy"}
          data={acrossHealthsy}
          className="filterModelNestedLevel filterModelOptions"
          activeFilters={acrossHealthsyData}
          onChange={(e) => {
            const selectedAcrossHealthsy = e.target.name;
            if (acrossHealthsyData.includes(selectedAcrossHealthsy)) {
              setAcrossHealthsyData(
                acrossHealthsyData.filter(
                  (data) => data !== selectedAcrossHealthsy,
                ),
              );
            } else {
              setAcrossHealthsyData((prev) => [
                ...prev,
                selectedAcrossHealthsy,
              ]);
            }
          }}
        />
      ) : null} */}

      {/* {sortshow ? (
        <div className="sortby-Common-career-main">
          <div
            onClick={() => {
              setTextColor(11);
              setSortShow(false);
              setSort("oldest");
              setSortName("Oldest");
            }}
            style={{
              color: textcolor === 11 ? "#CB1B5B" : "",
              fontWeight: textcolor === 11 ? "bold" : "",
            }}
          >
            Oldest
          </div>
          <div
            onClick={() => {
              setTextColor(12);
              setSortShow(false);
              setSort("newest");
              setSortName("Newest");
            }}
            style={{
              color: textcolor === 12 ? "#CB1B5B" : "",
              fontWeight: textcolor === 12 ? "bold" : "",
            }}
          >
            Newest
          </div>
          <div
            onClick={() => {
              setTextColor(13);
              setSortShow(false);
              setSort("ascending");
              setSortName("Ascending");
            }}
            style={{
              color: textcolor === 13 ? "#CB1B5B" : "",
              fontWeight: textcolor === 13 ? "bold" : "",
            }}
          >
            Alphabetical ↑
          </div>
          <div
            onClick={() => {
              setTextColor(14);
              setSortShow(false);
              setSort("descending");
              setSortName("Descending");
            }}
            style={{
              color: textcolor === 14 ? "#CB1B5B" : "",
              fontWeight: textcolor === 14 ? "bold" : "",
            }}
          >
            Alphabetical ↓
          </div>
        </div>
      ) : null} */}
      <ExcelDownloadModal
        onClickDownload={onClickDownload}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default Careers;
